module.exports = __webpack_public_path__ + "static/media/invitedFriends_100_250.d5cbb4b7.png";